import { Link } from 'react-router';
import { ButtonLink } from '@/components/ui/Button';
import { Mascot } from '@/components/ui/Mascot';
import { brand } from '@/config/brand';
import { useI18n } from '@/i18n/context';
import { LanguagePicker } from './LanguagePicker';

export function WelcomeScreen() {
  const { t, locale } = useI18n();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-8 py-6 text-center">
      <LanguagePicker className="self-end" />
      <Mascot mood="cheer" className="size-40" />
      <div className="flex flex-col gap-3">
        <h1 className="text-4xl font-black text-brand-800 sm:text-5xl">{t('welcome.title')}</h1>
        <p className="text-xl font-bold text-brand-700">{brand.tagline[locale]}</p>
        <p className="mx-auto max-w-xl text-lg text-ink-muted">{t('welcome.subtitle')}</p>
      </div>
      <ButtonLink to="/profiles/new" size="xl" className="min-w-64">
        {t('welcome.start')}
      </ButtonLink>
      <section className="w-full max-w-xl rounded-[var(--radius-card)] bg-surface p-5 text-start shadow-[var(--shadow-card)]">
        <h2 className="mb-3 text-lg font-extrabold">{t('welcome.privacyTitle')}</h2>
        <ul className="flex flex-col gap-2">
          {(['privacy1', 'privacy2', 'privacy3'] as const).map((key) => (
            <li key={key} className="flex items-start gap-2">
              <span aria-hidden className="text-brand-600">
                ✓
              </span>
              {t(`welcome.${key}`)}
            </li>
          ))}
        </ul>
        <Link
          to="/privacy"
          className="mt-3 inline-block font-bold text-sky-700 underline underline-offset-4"
        >
          {t('privacy.title')}
        </Link>
      </section>
      <Link to="/parent" className="font-bold text-ink-muted underline underline-offset-4">
        {t('welcome.parentArea')}
      </Link>
    </div>
  );
}
